export const userRoles = {
  ORGANIZATION_SUPER_USER: 1,
  DONATOR: 2,
  MEMBER: 3
}

export const userHelper = {
  data: function () {
    return {
    }
  },

  methods: {
    getRoleName: function (role) {
      switch (role) {
        case userRoles.ORGANIZATION_SUPER_USER:
          return this.$t('user.organization_super_user')
        case userRoles.DONATOR:
          return this.$t('user.donator')
        case userRoles.MEMBER:
          return this.$t('user.member')
      }
      return this.$t('common.unknown')
    },

    isOrganizationSuperUser: function (user) {
      if (!user || !user.organization) {
        return false
      }
      return user.roles.find(element => element === userRoles.ORGANIZATION_SUPER_USER) !== null
    },

    isNotAdmin: function (user) {
      return (user && !user.admin)
    },

    isValidPassword: function (psw) {
      return psw && psw.length >= 8
    }
  }
}
